import { Map } from "immutable"

import {
    REPORT_LIST_REQUEST as LIST_REQUEST,
    REPORT_LIST_RESPONSE as LIST_RESPONSE,
    REPORT_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    REPORT_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"
import { idify } from "./paging-reducer-utils"

const defaultSearchCriteria = Map({
    name: ""
})

const defaultReducer = buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)

export default (state = undefined, action) => {
    const { type } = action
    switch (type) {
        case LIST_RESPONSE:
            const data = action.data.map(reportOrGroup => {
                if (reportOrGroup.grouped_by) {
                    // Grouped return - process items by id
                    const itemIds = idify(reportOrGroup.items)
                    return {
                        ...reportOrGroup,
                        items: itemIds
                    }
                }
                return reportOrGroup
            })
            return defaultReducer(state, { ...action, data })
        default:
            return defaultReducer(state, action)
    }
}
